import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigParaService extends BaseService{

  private url = 'api/config-para';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  /**
   * 获取所有配置参数主表
   * @param type
   * @returns {Observable<any|any>}
   */
  getAll():Observable<any[]> {
    const url = `${this.getUrl()}/find-all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`findAll`)),
      catchError(this.handleError<any>(`findAll`))
    );
  }

  /**
   * 搜索配置参数主表与明细
   * @param type
   * @returns {Observable<any|any>}
   */
  getAllByValue(text):Observable<any[]> {
    const url = `${this.getUrl()}/search-by-text`;
    return this.http.get<any>(url, {params: {text: text}}).pipe(
      tap(_ => this.log(`search-by-text`)),
      catchError(this.handleError<any>(`search-by-text`))
    );
  }

  /**
   * 根据主表mainCode获取明细列表
   * @param type
   * @returns {Observable<any|any>}
   */
  getWithItemList(mainCode):Observable<any> {
    const url = `${this.getUrl()}/search-with-list`;
    return this.http.get<any>(url, {params: {mainCode:mainCode}}).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }
}
